module.exports = __webpack_public_path__ + "assets/img/88_519_3.1244994d.jpg";